export enum CommentTypes {
    Recruitment,
    Preboarding,
    Immigration,
    ProfileNotes
}
